/**
 * Toutes les notes circulent en **dixièmes entiers de 0 à 100** (85 = 8,5/10).
 *
 * Pourquoi pas un flottant : une moyenne de flottants stockée en base dérive, et l'égalité
 * stricte utilisée par les tests de podium devient fragile. Un entier de dixièmes se compare,
 * se moyenne et se sérialise sans surprise ; le formatage en « 8,5 » est une affaire d'affichage.
 */
export const SCORE_MIN = 0;
export const SCORE_MAX = 100;
/** 85 → "8,5" — la virgule décimale française, comme sur toutes les maquettes. */
export function toDisplayScore(tenths) {
    return (tenths / 10).toFixed(1).replace('.', ',');
}
/** "8,5" ou "8.5" ou 8.5 → 85. Renvoie null si la valeur n'est pas une note exploitable. */
export function fromDisplayScore(value) {
    const raw = typeof value === 'number' ? value : Number(value.replace(',', '.'));
    if (!Number.isFinite(raw))
        return null;
    const tenths = Math.round(raw * 10);
    if (tenths < SCORE_MIN || tenths > SCORE_MAX)
        return null;
    return tenths;
}
/**
 * La note globale n'est pas saisie : la maquette la présente comme un résultat qui bouge
 * pendant que le membre déplace ses trois curseurs.
 */
export function computeOverall(nose, palate, finish) {
    return Math.round((nose + palate + finish) / 3);
}
/** Moyenne d'un ensemble de notes, en dixièmes. Renvoie null sur un ensemble vide. */
export function averageScore(scores) {
    if (scores.length === 0)
        return null;
    return Math.round(scores.reduce((sum, s) => sum + s, 0) / scores.length);
}
// ------------------------------------------------------------------ pronostics à l'aveugle
/** Barème de proximité du pronostic. Un membre marque au maximum 8 points sur un rhum. */
export const GUESS_POINTS = {
    COUNTRY_EXACT: 3,
    TYPE_EXACT: 2,
    ABV_WITHIN_2: 2,
    AGE_WITHIN_2: 1,
};
export const GUESS_MAX_SCORE = GUESS_POINTS.COUNTRY_EXACT +
    GUESS_POINTS.TYPE_EXACT +
    GUESS_POINTS.ABV_WITHIN_2 +
    GUESS_POINTS.AGE_WITHIN_2;
/** Tolérance en degrés et en années au-delà de laquelle le pronostic ne marque plus. */
export const GUESS_TOLERANCE = 2;
//# sourceMappingURL=score.js.map